import { render, staticRenderFns } from "./BillRunLogs.vue?vue&type=template&id=464ddfa5&"
import script from "./BillRunLogs.vue?vue&type=script&lang=js&"
export * from "./BillRunLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BillRunLogs.vue"
export default component.exports